import moment from './moment';

export const CURRENCY = 'EUR';

export enum TransactionExpiration {
  MINUTES_15 = 'MINUTES_15',
  HOUR_1 = 'HOUR_1',
  DAY_1 = 'DAY_1',
  WEEK_1 = 'WEEK_1',
  MONTH_1 = 'MONTH_1',
  MONTH_3 = 'MONTH_3'
}

function replaceArticles(timeWithArticles: string) {
  return timeWithArticles.replace(/^(a |an |un |una )/, '1 ');
}

export function getExpirationDate(expireAfter: TransactionExpiration | undefined) {
  switch (expireAfter) {
    case TransactionExpiration.MINUTES_15:
      return moment().add(15, 'minute').unix();
    case TransactionExpiration.HOUR_1:
      return moment().add(1, 'hour').unix();
    case TransactionExpiration.DAY_1:
      return moment().add(1, 'day').unix();
    case TransactionExpiration.WEEK_1:
      return moment().add(1, 'week').unix();
    case TransactionExpiration.MONTH_1:
      return moment().add(1, 'month').unix();
    case TransactionExpiration.MONTH_3:
      return moment().add(3, 'month').unix();
    default:
      return moment().add(15, 'minute').unix();
  }
}

export const TRANSACTION_EXPIRATION_MAP: Record<TransactionExpiration, string> = {
  [TransactionExpiration.MINUTES_15]: replaceArticles(moment.duration(15, 'minutes').humanize()),
  [TransactionExpiration.HOUR_1]: replaceArticles(moment.duration(1, 'hour').humanize()),
  [TransactionExpiration.DAY_1]: replaceArticles(moment.duration(1, 'day').humanize()),
  [TransactionExpiration.WEEK_1]: replaceArticles(moment.duration(1, 'week').humanize()),
  [TransactionExpiration.MONTH_1]: replaceArticles(moment.duration(1, 'month').humanize()),
  [TransactionExpiration.MONTH_3]: replaceArticles(moment.duration(3, 'months').humanize())
} as const;
